import { ReactNode } from 'react';

import { useWatch, useUser } from 'hooks';

import { useRealTimeSubscription } from '../RealTime';

import { onlineActions } from './online.context';

// We want the watch/subscription to only happen once, thats why we have this here

export function OnlineUsersProvider({ children }: { children: ReactNode }) {
  const user = useUser();

  useWatch(user.id, (id) => id && onlineActions.add(id));

  useRealTimeSubscription('ONLINE_USERS', ({ ids }) => onlineActions.overwrite(ids));

  return <>{children}</>;
}
